import _ from "lodash";
import React, { Component } from "react";
import { Search, Grid, Icon } from "semantic-ui-react";
import "./styles/styles.css";
import ResultSearch from "./components/resultSearch";

const initialState = { isLoading: false, results: [], value: "" };

class BarSearch extends Component {
  state = initialState;

  // handleResultSelect = (e, { result }) =>
  //   this.setState({ value: result.keywords });

  handleSearchChange = (e, { value }) => {
    this.setState({ isLoading: true, value });

    setTimeout(() => {
      if (this.state.value.length < 1) return this.setState(initialState);

      const re = new RegExp(_.escapeRegExp(this.state.value.toLowerCase()));
      const isMatch = result => re.test(result.keywords);

      let array = [];
      this.props.products.forEach(element => {
        array.push({
          identificador: element.id,
          name: element.data.name,
          code: element.data.code,
          images: element.data.images,
          keywords: element.data.keyWords
            ? element.data.keyWords.split(",")
            : element.data.keyWords
        });
      });
      this.setState({
        isLoading: false,
        results: _.filter(array, isMatch)
      });
    }, 0);
  };

  handleExit = () => {
    this.props.setVisibleSearch(false);
  };

  resultRenderer = (data, id) => <ResultSearch data={data} key={id} />;

  render() {
    const { isLoading, value, results } = this.state;
    return (
      <Grid
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Grid.Column width={16}>
          <Search
            placeholder="Buscar..."
            icon={
              this.props.clave === "movil" ? null : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Icon
                    name="remove"
                    size="small"
                    onClick={() =>
                      this.props.clave ? null : this.handleExit()
                    }
                    /* className={
                    this.props.mylocation === "/" ? "exit" : "exitblack"
                  } */
                    className={"exitblack"}
                  />
                </div>
              )
            }
            loading={isLoading}
            //onResultSelect={this.handleResultSelect}
            onSearchChange={_.debounce(this.handleSearchChange, 500, {
              leading: true
            })}
            resultRenderer={this.resultRenderer}
            results={results}
            value={value}
            {...this.props}
            size={this.props.clave === "movil" ? "mini" : "big"}
          />
        </Grid.Column>
      </Grid>
    );
  }
}

export default BarSearch;
